import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";
import { PropertyWithGroupsSchema } from "./ShowPropertiesResponse";
import { BaseResponseSchema } from "../../common/response/BaseResponseSchema";

const IndexPropertiesResponse = BaseResponseSchema.extend({
    data: z.array(PropertyWithGroupsSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

const PropertySchema = PropertyWithGroupsSchema;

export { IndexPropertiesResponse, PropertySchema };
export type IndexPropertiesResponseType = z.infer<typeof IndexPropertiesResponse>;
export type PropertyResponseType = z.infer<typeof PropertySchema>;